export default __webpack_public_path__ + "static/data-vis-chart-data-light-5e58721aa93c89d1343aba71968518c3c71b4727c339c3f526add68422543af7.png";